@if (deviceService.$isMobile()) {
<lib-bottom-sheet
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="true"
  [closeOnEscape]="true"
  [headerTemplate]="headerTpl"
>
  <ng-container *ngTemplateOutlet="conteudoTpl"></ng-container>
</lib-bottom-sheet>
} @else {
<p-dialog
  header="Escolha um plano"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  appendTo="body"
  [dismissableMask]="true"
  styleClass="n-dialog rp-dialog"
  [style]="{ width: '520px', maxWidth: '95vw', maxHeight: '85vh' }"
  [contentStyle]="{ overflowY: 'auto', maxHeight: 'calc(85vh - 4.5rem)' }"
  (onHide)="fechar.emit()"
>
  <ng-container *ngTemplateOutlet="conteudoTpl"></ng-container>
</p-dialog>
}

<ng-template #headerTpl>
  <div class="rp-sheet-header">
    <h2>Escolha um plano</h2>
  </div>
</ng-template>

<ng-template #conteudoTpl>
  @if ($loading()) {
  <div class="rp-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
  } @else if ($planos().length === 0) {
  <p class="rp-empty">Nenhum plano disponível para este sistema.</p>
  } @else {
  @if ($temPrecoAnual()) {
  <div class="rp-interval-toggle">
    <p-selectButton
      [options]="intervalOptions"
      [(ngModel)]="billingInterval"
      optionLabel="label"
      optionValue="value"
    ></p-selectButton>
  </div>
  }
  <div class="rp-planos-grid">
    @for (plano of $planos(); track plano.id) {
    <div class="rp-plano-card">
      <div class="rp-plano-info">
        <h3 class="rp-plano-nome">{{ plano.nome }}</h3>
        @if (plano.descricao) {
        <p class="rp-plano-descricao">{{ plano.descricao }}</p>
        }
        <div class="rp-plano-preco">
          <span [class.rp-preco-indisponivel]="!precoAtual(plano)">
            {{ formatarPreco(precoAtual(plano)) }}
          </span>
          @if (precoAtual(plano)) {
          <small>/{{ billingInterval === 'year' ? 'ano' : 'mês' }}</small>
          }
        </div>
        @if (avisoZapNoCheckout(plano)) {
        <p class="rp-plano-aviso-zap">
          Não inclui WhatsApp Zap. A conexão atual será encerrada.
        </p>
        }
      </div>
      <button
        pButton
        class="p-button-rounded rp-btn-escolher"
        [loading]="$processando() === plano.id"
        [disabled]="$processando() !== null || !precoAtual(plano)"
        (click)="escolherPlano(plano)"
      >
        Escolher
      </button>
    </div>
    }
  </div>
  }
</ng-template>

<p-confirmDialog appendTo="body" [style]="{ width: 'min(420px, 95vw)' }" />
